import { Typography } from "@mui/material";

import Svg, { SvgEnum } from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";
import { STRINGS } from "../../config/strings";

export default function MapControls({ isFullscreen, toggleFullscreen, showMap, setShowMap }) {
  return (
    <>
      <button
        id="fullscreen-btn"
        onClick={toggleFullscreen}
        aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
        className="absolute bottom-4 left-4 z-50 flex items-center justify-center rounded-[5.36px] bg-white p-2 shadow-md hover:bg-gray-100"
      >
        <Svg
          name={isFullscreen ? SvgEnum.HisMinimize : SvgEnum.HisMaximize}
          color={HNSColors.primary[500]}
          sx={{ width: 24, height: 24 }}
        />
      </button>

      <div className="absolute bottom-4 right-4 z-50 flex flex-col items-end gap-2">
        <button
          id="map-visibility-btn"
          onClick={() => setShowMap(!showMap)}
          aria-label="Show Map View"
          className="flex items-center justify-center gap-2 rounded-[5.36px] px-2 py-1 shadow-md"
          style={{ backgroundColor: HNSColors.neutrals[900] }}
        >
          <Typography className="text-[14px]">
            {showMap ? STRINGS.BUTTON_LABELS.HIDE_MAP : STRINGS.BUTTON_LABELS.SHOW_MAP}
          </Typography>
            <span
              className="flex items-center justify-center rounded-[5.36px] p-1"
              style={{ backgroundColor: HNSColors.primary[500] }}
            >
              <Svg
                name={showMap ? SvgEnum.HisEyeOff : SvgEnum.HisEye}
                color={HNSColors.neutrals[900]}
                sx={{ width: 20, height: 20 }}
              />
            </span>
        </button>
      </div>
    </>
  );
}
